import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  private apiUrl = environment.baseApiUrl + "/feedbacks";

  constructor(private http: HttpClient) { }

  createFeedback(data: any): Observable<any> {
    return this.http.post(this.apiUrl + "/store", data, {
      headers: { 'Content-Type': 'application/json' }
    })
  }

}
